import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Link, To } from 'react-router';
import Image from './skeleton/ImageComponent'

interface CityObj {
    imageUrl: string;
    city: string;
    rank: number;
    // Comma-separated "lat,lng" string; optional here since only some consumers
    // (e.g. SearchRedirectPopularLocationListingItem) read it.
    coordinates?: string;
}

interface PopularLocationListingItemProps {
    // Widened from `string` to react-router's `To` since callers (e.g.
    // SearchRedirectPopularLocationListingItem) pass a { pathname, search } object.
    linkTo: To;
    cityObj: CityObj;
}

// Matches theme.components.helperText from globalThemes.js
const numListingsSx = {
    fontFamily: 'Inter',
    fontSize: '0.86rem',
    fontWeight: 400,
    lineHeight: '167%',
    letterSpacing: '0.03rem',
} as const;

const PopularLocationListingItem = (props: PopularLocationListingItemProps) => {
    return (
        <Grid className="location-panel" item  container>
            <Grid item md={3}>
                <Link to={props.linkTo}>
                    <Image
                        src={props.cityObj.imageUrl}
                        className="city-img"
                        alt={props.cityObj.city}
                        errorImg='../app-images/city_placeholder.jpg'
                        placeHolderimg="https://miro.medium.com/v2/resize:fit:512/0*pyRw1qikTI1eqGm9.gif"
                    />
                </Link>
            </Grid>
            <Grid className="location-details-container" item xs>
                <Link to={props.linkTo}>
                    <Typography className="location-name" variant="subtitle2" color="secondary">
                        {props.cityObj.city}
                    </Typography>
                </Link>
                <Typography sx={numListingsSx} color="textSecondary">{props.cityObj.rank} listings</Typography>
            </Grid>
        </Grid>
    );
};

export default PopularLocationListingItem;
